<template>
  <div
    ref="modal"
    class="modal fade"
    tabindex="-1"
    aria-labelledby="connectGroupToCRMLabel"
    aria-hidden="true"
  >
    <div class="modal-dialog modal-dialog-centered">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title" id="connectGroupToCRMLabel">
            Connect Group to CRM Partner
          </h5>
          <button
            type="button"
            class="btn-close"
            data-bs-dismiss="modal"
            aria-label="Close"
          ></button>
        </div>
        <div class="modal-body">
          <div class="form-group mb-3">
            <label class="form-label">Select Partner</label>
            <v-select
              :options="partners"
              :filterable="false"
              v-model="selectedPartner"
              label="name"
              placeholder="Select a partner"
              :reduce="(c) => c.id"
              append-to-body
            />
          </div>
        </div>
        <div class="modal-footer">
          <button
            type="button"
            class="btn btn-secondary"
            data-bs-dismiss="modal"
          >
            Cancel
          </button>
          <button
            type="button"
            class="btn btn-primary"
            :disabled="!selectedPartner"
            @click="connectGroup"
          >
            Connect
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import http from "../../modules/http";
const bootstrap = require("bootstrap");

export default {
  name: "ConnectGroupToCRM",
  props: {
    group: Object,
  },
  emits: ["connected"],
  data() {
    return {
      myModal: undefined,
      partners: [],
      selectedPartner: null,
    };
  },
  mounted() {
    // Load partners when modal is mounted
    this.loadPartners();
  },
  methods: {
    showModal() {
      if (this.myModal === undefined) {
        this.myModal = new bootstrap.Modal(this.$refs.modal, {
          backdrop: "static",
        });
      }
      this.myModal.show();
    },
    hideModal() {
      if (this.myModal) {
        this.myModal.hide();
      }
    },
    loadPartners() {
      http.fetch("/crm/partners").then((data) => {
        this.partners = data.data;
      });
    },
    connectGroup() {
      if (!this.selectedPartner || !this.group) return;

      console.log(
        "Connecting group",
        this.group.id,
        "to partner",
        this.selectedPartner
      );

      http
        .fetch(
          `/work/task-groups/${this.group.id}/connect-to-crm`,
          { partner_id: this.selectedPartner },
          true
        )
        .then((res) => {
          if (res.success) {
            this.$emit("connected", res.group.crmPartner);
            this.hideModal();
          } else {
            console.error("Failed to connect group to CRM");
          }
        })
        .catch((error) => {
          console.error("Error connecting group to CRM:", error);
        });
    },
  },
};
</script>
